import { useMemo } from 'react'

import { banners as allBanners } from '@/common/data/loaders/banner/banners'
import type { BannerLoaded } from '@/common/data/loaders/banner/types'
import { isNotNull } from '@/utils/helpers'

import { useAppContext } from '@/client/context/app'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'

export function useBannersLoader(): BannerLoaded[] {
  const user = useUser()
  const query = useQuery()
  const { requestTimestamp } = useAppContext()

  const cachedBanners = useMemo(
    () =>
      allBanners.flatMap(bannerLoader => {
        const result = bannerLoader.load({ user, query, requestTimestamp })
        if (result == null) {
          return []
        }
        const banners = (Array.isArray(result) ? result : [result]).filter(isNotNull)

        return banners.map(banner => ({
          name: bannerLoader.name,
          slug: bannerLoader.name,
          sticky: false,
          link: null,
          icon: null,
          // ^ defaults
          ...banner,
        }))
      }),
    [user, query, requestTimestamp]
  )

  return cachedBanners
}
